import component from "./Router";

export default component;
